<template>
  <GenericModal
    v-model="isOpen"
    :wide="true">
    <div class="c-modal__header">
      <div class="c-modal__title">
        {{ $t('notificationSettings.browser_notifications_tutorial_title') }}
      </div>
      <button
        class="c-modal__close"
        @click="isOpen = false">
        <SvgIcon
          type="close"
          small />
      </button>
    </div>
    <div class="c-modal__content o-textbody">
      <p class="u-colorDark u-marginBottom2">
        {{ currentBrowserLabel }}
      </p>
      <ul class="u-marginBottom3">
        <li
          v-for="(step, idx) in steps"
          :key="idx">{{ step }}</li>
      </ul>
    </div>
    <div class="c-modal__actions">
      <button
        type="button"
        class="c-button"
        @click="isOpen = false">{{ $t('generic.close') }}</button>
    </div>
  </GenericModal>
</template>

<script setup>
import { computed } from 'vue'

import getI18n from '@/logic/i18nInstance'

const i18n = getI18n()

const props = defineProps({
  value: {
    type: Boolean,
    default: false,
  },
})
const emit = defineEmits(['input'])

const isOpen = computed({
  get() {
    return props.value
  },
  set(v) {
    emit('input', v)
  },
})

const browser = computed(() => {
  if (typeof navigator === 'undefined') {
    return 'other'
  }
  const ua = navigator.userAgent
  if (/Edg\//.test(ua) || /Edge\//.test(ua)) {
    return 'edge'
  }
  if (/Firefox\//.test(ua)) {
    return 'firefox'
  }
  // Safari on iOS and macOS includes "Safari" but not "Chrome" or "Chromium"
  if (/Safari\//.test(ua) && !/Chrome\//.test(ua) && !/Chromium\//.test(ua)) {
    return 'safari'
  }
  if (/Chrome\//.test(ua) || /Chromium\//.test(ua)) {
    return 'chrome'
  }
  return 'other'
})

const currentBrowserLabel = computed(() => {
  const labels = {
    chrome: 'Google Chrome',
    firefox: 'Mozilla Firefox',
    safari: 'Safari',
    edge: 'Microsoft Edge',
    other: 'Browser',
  }
  return labels[browser.value]
})

const currentUrl = computed(() => `https://${window.location.hostname}`)

const steps = computed(() => {
  const base = 'notificationSettings.browser_notifications_tutorial.'
  const key = base + (['chrome', 'firefox', 'safari', 'edge'].includes(browser.value) ? browser.value : 'chrome')
  // First fetch without replacements. If this is an array, translate each item individually
  const raw = i18n.t(key)
  if (Array.isArray(raw)) {
    return raw.map((_, idx) => String(i18n.t(`${key}.${idx}`, { url: currentUrl.value })))
  }
  // Fallback to single translation with replacements
  return [String(i18n.t(key, { url: currentUrl.value }))]
})
</script>
